import { Pipe, PipeTransform } from '@angular/core';

import { Account } from '@libs/src/models/account.model';
import { getUserPronouns } from '@main-client/src/app/user/user.helpers';

@Pipe({
  name: 'appDisplayUserPronouns',
})
export class DisplayUserPronounsPipe implements PipeTransform {
  transform(user: Account): any {
    const userPronouns = getUserPronouns(user);
    if (!userPronouns) {
      return;
    }
    return `(${user.pronouns})`;
  }
}
